import {
  createTransportEntitiesResourceGuard,
  deleteTransportEntitiesResourceGuard,
  editTransportEntitiesResourceGuard,
  transportEntitiesCollectionGuard,
  transportEntitiesResourceGuard,
  transportEntitiesTypesCollectionGuard,
} from './_api/transportEntities';

export const resourceTransportEntitiesRoutes = transportEntitiesResourceGuard;
export const deleteTransportEntitiesRoutes =
  deleteTransportEntitiesResourceGuard;
export const createTransportEntitiesRoutes =
  createTransportEntitiesResourceGuard;
export const collectionTransportEntitiesRoutes =
  transportEntitiesCollectionGuard;
export const editTransportEntitiesRoutes = editTransportEntitiesResourceGuard;
export const resourceTransportEntitiesTypesGuard =
  transportEntitiesTypesCollectionGuard;

export const routeGuard = transportEntitiesCollectionGuard;
